import React from "react";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import CommonFooter from "../components/CommonFooter/CommonFooter";
import GetFinance from "../components/GetFinance/GetFinance";

const GetFinancePage = () => {
  return (
    <div>
      <CommonNavbar hide_btn="d-none" show_btn="d-block" />
      <GetFinance />
      <CommonFooter />
    </div>
  );
};

export default GetFinancePage;
